export const MAX_FAVOURITES = 30;
export const CREDIT_CARD = 'credit_card';
export const ACCOUNT_PICKER_LAYOUT = 'ACCOUNT_PICKER_LAYOUT';
export const PAYEE_PICKER_LAYOUT = 'PAYEE_PICKER_LAYOUT';
export const LARGE_CUSTOMER_MIN_ACCOUNTS_SIZE = 31;
export const SINGLE_ACCOUNT = 1;
